import { useMemo } from 'react';
import { useSonarSelector } from './useSonarSelector';
import { createCollectionSelector, createDataSelector } from '../lib/selectors';
export function useAsyncCollection(stateSelector) {
    const resultSelector = useMemo(() => createCollectionSelector(createDataSelector(stateSelector)), [stateSelector]);
    const stateCollection = useSonarSelector(resultSelector);
    return useMemo(() => stateCollection !== null && stateCollection !== void 0 ? stateCollection : [], [stateCollection]);
}
